@use "colors" as *;

.dontCry {
  font-family: "Roboto";
  .wrapper {
    width: 100vw;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80vh;
    width: 100vw;
    flex-direction: column;
    h1,
    h2,
    p {
      color: $grey;
      font-family: "Roboto Mono";
    }
  }
}
